export default __webpack_public_path__ + "static/media/logo.055b0c83.png";